const DEFAULT_TRY_ON_POLL_INTERVAL_SECONDS = 5;
const DEFAULT_TRY_ON_POLL_MAX_SECONDS = 300;

function parsePositiveSeconds(value: string, fallbackSeconds: number) {
  const numericValue = Number.parseFloat(value.trim());
  return Number.isFinite(numericValue) && numericValue > 0
    ? numericValue
    : fallbackSeconds;
}

function resolvePollingStartedAtMs(startedAt: number | string | null | undefined, fallbackMs: number) {
  if (typeof startedAt === 'number' && Number.isFinite(startedAt) && startedAt > 0) {
    return startedAt;
  }

  if (typeof startedAt === 'string') {
    const parsedStartedAtMs = Date.parse(startedAt);
    if (Number.isFinite(parsedStartedAtMs)) {
      return parsedStartedAtMs;
    }
  }

  return fallbackMs;
}

export function getTryOnPollIntervalMilliseconds(
  value: string,
  fallbackSeconds = DEFAULT_TRY_ON_POLL_INTERVAL_SECONDS
) {
  return Math.round(parsePositiveSeconds(value, fallbackSeconds) * 1000);
}

export function getTryOnPollMaxMilliseconds(
  value: string,
  fallbackSeconds = DEFAULT_TRY_ON_POLL_MAX_SECONDS
) {
  return Math.round(parsePositiveSeconds(value, fallbackSeconds) * 1000);
}

export function hasTryOnPollingTimedOut(
  startedAt: number | string | null | undefined,
  maxPollMs: number,
  nowMs = Date.now()
) {
  return nowMs - resolvePollingStartedAtMs(startedAt, nowMs) >= maxPollMs;
}
